var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.836 7.5V5a3.333 3.333 0 00-6.667 0v2.5M3.496 8.625l-.5 5.333c-.142 1.517-.213 2.275.038 2.86a2.5 2.5 0 001.1 1.209c.56.305 1.321.305 2.844.305h7.049c1.523 0 2.284 0 2.844-.305a2.5 2.5 0 001.1-1.208c.252-.586.18-1.344.038-2.86l-.5-5.334c-.12-1.28-.18-1.92-.468-2.405a2.5 2.5 0 00-1.076-.98c-.51-.242-1.152-.242-2.438-.242H7.478C6.192 5 5.55 5 5.04 5.241a2.5 2.5 0 00-1.076.98c-.288.484-.348 1.124-.468 2.405z",
    stroke: "#000",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgOrderHistory;